import { render, staticRenderFns } from "./task-archive-popup.vue?vue&type=template&id=15dd2352&"
import script from "./task-archive-popup.vue?vue&type=script&lang=js&"
export * from "./task-archive-popup.vue?vue&type=script&lang=js&"
import style0 from "./task-archive-popup.vue?vue&type=style&index=0&id=15dd2352&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports